import React from 'react'
import DataGrid from 'react-data-grid'
import './index.css'

const Request: React.FC = () => {
    const column = [
        {
            key: 'type',
            name: `Type`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: `Status`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return <div className="status">{props.row.status}</div>
            },
        },
        {
            key: 'date',
            name: `Date`,
            resizable: true,
            sortable: true,
        },

        {
            key: 'description',
            name: `Description`,
            resizable: true,
            sortable: true,
        },
    ]

    const rows = []

    for (let i = 0; i < 4; i++) {
        rows.push({
            type: 'Vacation',
            date: 'Jan 1 - Jan 14, 2024',
            status: 'Pending',
            description: 'Lorem ipsum dolor sit amet consectetur. ',
        })
    }

    return (
        <div>
            <div className="col-12 grid-custom-table grid-table-timeoff">
                <DataGrid
                    className="data-grid-table"
                    columns={column}
                    // rowKeyGetter={(row: Brand) => row.id}
                    rows={rows}
                    rowHeight={60}
                    headerRowHeight={40}
                    // onCellClick={(row) => {
                    //     setSelectedBrand(row.row)
                    // }}
                    // sortColumns={sortColumns}
                    // onSortColumnsChange={setSortColumns}
                />
            </div>
        </div>
    )
}

export default Request
